import {useRef, useEffect, useState} from 'react';
import LatestNews from './LatestNews';

// Use public paths for production build compatibility
// process.env.PUBLIC_URL is empty in development, but includes the base path in production
const basePath = process.env.PUBLIC_URL || '';
const admissionFormPdf = `${basePath}/images/flyer/KCEadmissionform.pdf`;
const admissionImage1 = `${basePath}/images/flyer/flyer1.jpeg`;
const admissionImage2 = `${basePath}/images/flyer/flyer2.jpeg`;
const admissionImage3 = `${basePath}/images/flyer/flyer3.jpeg`;
const admissionImage4 = `${basePath}/images/flyer/flyer4.jpeg`;

const UpcomingEvents = ({hideHeading = false, hideLatestNews = false}) => {
  const videoRef = useRef (null);
  const [eventImages, setEventImages] = useState ([]);
  const [loading, setLoading] = useState (true);

  // Fetch event images dynamically
  useEffect (() => {
    const fetchEventImages = async () => {
      try {
        // Try JSON file first (works in development/localhost)
        let response = await fetch ('/images/events/images.json');
        let data = null;

        if (response.ok) {
          const text = await response.text ();
          // Check if it's valid JSON or PHP code
          if (
            text.trim ().startsWith ('<?php') ||
            text.trim ().startsWith ('<!')
          ) {
            // This shouldn't happen with JSON, but if it does, try PHP
            response = await fetch ('/images/events/images.php');
            if (response.ok) {
              const phpText = await response.text ();
              if (
                !phpText.trim ().startsWith ('<?php') &&
                !phpText.trim ().startsWith ('<!')
              ) {
                data = JSON.parse (phpText);
              }
            }
          } else {
            // Valid JSON
            data = JSON.parse (text);
          }
        } else {
          // JSON doesn't exist, try PHP (for production server)
          response = await fetch ('/images/events/images.php');
          if (response.ok) {
            const text = await response.text ();
            // Check if PHP was executed (should be JSON) or raw PHP code
            if (
              !text.trim ().startsWith ('<?php') &&
              !text.trim ().startsWith ('<!')
            ) {
              data = JSON.parse (text);
            }
          }
        }

        if (data && data.images && data.images.length > 0) {
          // Filter out the main SHIKSHA SANGAMA image (we show it separately)
          const otherImages = data.images.filter (
            img => !img.includes ('KCE-SHIKSHA-SANGAMA.jpg')
          );
          setEventImages (otherImages);
        } else {
          setEventImages ([]);
        }
        setLoading (false);
      } catch (error) {
        console.error ('Error loading event images:', error);
        setLoading (false);
        setEventImages ([]);
      }
    };

    fetchEventImages ();
  }, []);

  useEffect (() => {
    const playVideo = async () => {
      if (videoRef.current) {
        try {
          await videoRef.current.play ();
        } catch (error) {
          // Browser may block autoplay with sound - try again after a short delay
          setTimeout (() => {
            if (videoRef.current) {
              videoRef.current.play ().catch (() => {
                // Autoplay blocked - user will need to click play
              });
            }
          }, 500);
        }
      }
    };

    playVideo ();
  }, []);
  return (
    <section className="ftco-section ftco-no-pb">
      <div className="container">
        {!hideHeading &&
          <div className="row justify-content-center pb-4">
            <div className="col-md-12  heading-section ftco-animate text px-4">
              <h2 className="mb-4 text-success text-center">
                <span className="text-warning">Upcoming </span> Events
              </h2>
            </div>
          </div>}

        <div className="row mt-3">
          <div className=" col-md-12 order-md-first">
            <div className="text px-4 heading-section">

              <div className="row mt-3">
                <div className="col-md-12 order-md-first">
                  <div className="text px-4 heading-section">

                    <h2 className="mb-4 text-center">
                      <span>B.Ed Admission Open : </span> 2026 - 2027
                    </h2>

                    <div className="row g-4 align-items-start mb-4">

                      <div className="col-12 col-lg-12">

                        {/* Carousel */}
                        <div
                          id="admissionCarousel"
                          className="carousel slide rounded overflow-hidden bg-white"
                          data-bs-ride="carousel"
                          data-bs-interval="3000"
                        >
                          {/* Dots */}
                          <div className="carousel-indicators">
                            <button
                              type="button"
                              data-bs-target="#admissionCarousel"
                              data-bs-slide-to="0"
                              className="active"
                              aria-current="true"
                              aria-label="Slide 1"
                              style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: '#0d6efd',
                              }}
                            />

                            <button
                              type="button"
                              data-bs-target="#admissionCarousel"
                              data-bs-slide-to="1"
                              aria-label="Slide 2"
                              style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: '#0d6efd',
                              }}
                            />

                            <button
                              type="button"
                              data-bs-target="#admissionCarousel"
                              data-bs-slide-to="2"
                              aria-label="Slide 3"
                              style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: '#0d6efd',
                              }}
                            />
                            <button
                              type="button"
                              data-bs-target="#admissionCarousel"
                              data-bs-slide-to="3"
                              aria-label="Slide 4"
                              style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: '#0d6efd',
                              }}
                            />
                          </div>

                          {/* Slides */}
                          <div className="carousel-inner">

                            <div className="carousel-item active">
                              <img
                                src={admissionImage1}
                                alt="Admission 1"
                                className="d-block w-100 bg-white"
                                style={{
                                  maxHeight: '500px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>

                            <div className="carousel-item">
                              <img
                                src={admissionImage2}
                                alt="Admission 2"
                                className="d-block w-100 bg-white"
                                style={{
                                  maxHeight: '500px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>

                            <div className="carousel-item">
                              <img
                                src={admissionImage3}
                                alt="Admission 3"
                                className="d-block w-100 bg-white"
                                style={{
                                  maxHeight: '500px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div className="carousel-item">
                              <img
                                src={admissionImage4}
                                alt="Admission 4"
                                className="d-block w-100 bg-white"
                                style={{
                                  maxHeight: '500px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>

                          </div>
                        </div>

                        {/* Center Buttons */}
                        <div className="mt-4 d-flex justify-content-center gap-3 flex-wrap">
                          <a
                            className="btn btn-primary px-4"
                            href={admissionFormPdf}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View PDF
                          </a>

                          <a
                            className="btn btn-outline-primary px-4"
                            href={admissionFormPdf}
                            download
                          >
                            Download PDF
                          </a>
                        </div>

                      </div>
                    </div>

                    {!hideLatestNews && <LatestNews />}

                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      <hr className="custom-hr" />
    </section>
  );
};

export default UpcomingEvents;
